import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { View } from '@uncinc/react-drupal-core';

const TYPE = {
  article: 'article',
  project: 'project',
};

const PrevNext = ({ date, type, articleTypeName }) => {
  const filters = {
    created: {
      value: date,
    },
    field_system_name_value: articleTypeName,
  };

  return (
    <Container>
      <div className="row">
        <div className="col-12 PrevNext__wrapper">
          <div className="PrevNext">
            <div className="row">
              <div className="col-md-6 first">
                <div className="PrevNext__item">
                  {type === TYPE.article ? (
                    <View
                      className="PreviousNextArticle__view"
                      id="previous_next_article"
                      filters={filters}
                      display="prev"
                    />
                  ) : (
                    <View
                      className="PreviousNextProject__view"
                      id="previous_next_project"
                      filters={filters}
                      display="prev"
                    />
                  )}
                </div>
              </div>
              <div className="col-md-6 second">
                <div className="PrevNext__item">
                  {type === TYPE.article ? (
                    <View
                      className="PreviousNextArticle__view"
                      id="previous_next_article"
                      filters={filters}
                      display="next"
                    />
                  ) : (
                    <View
                      className="PreviousNextProject__view"
                      id="previous_next_project"
                      filters={filters}
                      display="next"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PrevNext;
